@if (showSpinner) {
  <app-loader> </app-loader>
}
@if (isNewsUpdateShow && isNewsUpdateModalShow) {
  <app-news-updates [mediaObject]="mediaObject"></app-news-updates>
}
<div class="main-dashboard-wrapper">
  <div class="inner-section-dashboard">
    <div class="header-inner-setion">
      <div class="inner-common">
        <div class="card-main">
          <div class="row">
            <div class="col-12">
              <div class="card-heading">
                <h1>Today Report</h1>
              </div>
            </div>
            <div class="today-report-main">
              <div class="comon-report-section">
                <div class="semidonut-chart-section">
                  <div class="semi-donut margin" style="--percentage : {{percentageInProgress}};  margin: 0 auto;">
                    <div class="report-timer">
                      <h1>
                        {{remaininghours ?? "00"}}
                        <span class="full-form">Hours</span>
                        <span class="short-form">HH</span>
                      </h1>
                      <h1>
                        :
                      </h1>
                      <h1>
                        {{remainingminutes ?? "00"}}
                        <span class="full-form">Minutes</span>
                        <span class="short-form">MM</span>

                      </h1>
                      <h1>
                        :
                      </h1>
                      <h1>
                        {{remaininseconds ?? "00"}}
                        <span class="full-form">Seconds</span>
                        <span class="short-form">SS</span>

                      </h1>
                    </div>
                  </div>
                  <div class="punchin-button">
                    @if (shouldShowPunchIn()) {
                      <button class="pounch-in" (click)="getCheckInDetail()" [disabled]="isSecondShiftEmployee()"
                        >
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.00008 5.5415V7.87484L8.45841 8.74984M7.00008 2.9165C4.26167 2.9165 2.04175 5.13643 2.04175 7.87484C2.04175 10.6132 4.26167 12.8332 7.00008 12.8332C9.73849 12.8332 11.9584 10.6132 11.9584 7.87484C11.9584 5.13643 9.73849 2.9165 7.00008 2.9165ZM7.00008 2.9165V1.1665M5.83341 1.1665H8.16675M11.8587 3.26186L10.9837 2.38686L11.4212 2.82436M2.14151 3.26186L3.01651 2.38686L2.57901 2.82436"
                            stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          Punch In
                        </button>
                      }
                      @if (shouldShowPunchOut()) {
                        <button (click)="getCheckOutDetail()" [disabled]="isSecondShiftEmployee()"
                          >
                          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.00008 5.5415V7.87484L8.45841 8.74984M7.00008 2.9165C4.26167 2.9165 2.04175 5.13643 2.04175 7.87484C2.04175 10.6132 4.26167 12.8332 7.00008 12.8332C9.73849 12.8332 11.9584 10.6132 11.9584 7.87484C11.9584 5.13643 9.73849 2.9165 7.00008 2.9165ZM7.00008 2.9165V1.1665M5.83341 1.1665H8.16675M11.8587 3.26186L10.9837 2.38686L11.4212 2.82436M2.14151 3.26186L3.01651 2.38686L2.57901 2.82436"
                              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Punch Out
                          </button>
                        }


                      </div>

                    </div>
                  </div>
                  <div class="comon-report-section">
                    <div class="shift-detail-section">
                      <div class="col-12 p-0">
                        <div class="shift-detail-head">
                          <h1>Shift Details</h1>
                        </div>
                      </div>
                      <div class="shift-detail-main">
                        <div class="shift-time">
                          <div class="border-section">
                            <div class="circle bule-circle">

                            </div>
                          </div>
                          <div class="shit-content-sec">
                            <h2>Shift Time</h2>
                            <h1>
                              <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M7.00008 3.49984V6.99984L9.33341 8.1665M12.8334 6.99984C12.8334 10.2215 10.2217 12.8332 7.00008 12.8332C3.77842 12.8332 1.16675 10.2215 1.16675 6.99984C1.16675 3.77818 3.77842 1.1665 7.00008 1.1665C10.2217 1.1665 12.8334 3.77818 12.8334 6.99984Z"
                                  stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>{{ user.usershittime[0].start_time ?? "00:00" }}</span> To
                                <Span>{{user.usershittime[0].end_time ?? "00"}}</Span>
                              </h1>
                            </div>
                          </div>

                          <div class="shift-time">
                            <div class="border-section">
                              <div class="circle pink-circle">

                              </div>
                            </div>
                            <div class="shit-content-sec">
                              <h2>Total Shift Hours</h2>
                              <h1>
                                <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                  xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M6.00008 5.5415V7.87484L7.45841 8.74984M6.00008 2.9165C3.26167 2.9165 1.04175 5.13643 1.04175 7.87484C1.04175 10.6132 3.26167 12.8332 6.00008 12.8332C8.73849 12.8332 10.9584 10.6132 10.9584 7.87484C10.9584 5.13643 8.73849 2.9165 6.00008 2.9165ZM6.00008 2.9165V1.1665M4.83341 1.1665H7.16675M10.8587 3.26186L9.98365 2.38686L10.4212 2.82436M1.14151 3.26186L2.01651 2.38686L1.57901 2.82436"
                                    stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                  </svg>
                                  <span>{{user.usershittime[0].total_working_hours ?? 0}} Hours</span>
                                </h1>
                              </div>
                            </div>
                            <div class="shift-time">
                              <div class="border-section last-border-section">
                                <div class="circle yellow-circle">

                                </div>
                              </div>
                              <div class="shit-content-sec">
                                <h2>Punch in at</h2>
                                <h1>
                                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M8.45841 11.0832L9.62508 12.2498L12.2501 9.62484M12.8247 7.3206C12.8305 7.21441 12.8334 7.10746 12.8334 6.99984C12.8334 3.77818 10.2217 1.1665 7.00008 1.1665C3.77842 1.1665 1.16675 3.77818 1.16675 6.99984C1.16675 10.1705 3.69638 12.7503 6.84753 12.8312M7.00008 3.49984V6.99984L9.1808 8.0902"
                                      stroke="#2D2D2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span>{{ checkInTime ?? "Need to Do Punch In" }}</span>
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inner-common">
                  <div class="card-main">
                    <div class="row">
                      <div class="col-12">
                        <div class="card-heading">
                          <h1 class="mb-0">Attendance Report</h1>
                          <div class="chart-button">
                            <button (click)="filterBars('all')">
                              <div class="chart-color all-bar"></div>All
                            </button>
                            <button (click)="filterBars('overtime')">
                              <div class="chart-color overtime-bar"></div> Overtime
                            </button>
                            <button (click)="filterBars('allGood')">
                              <div class="chart-color allgood-bar"></div>All Good
                            </button>
                            <button (click)="filterBars('shortTime')">
                              <div class="chart-color short-bar"></div>Short Time
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div id="chart">
                        <apx-chart [series]="chartOptions.series" [grid]="chartOptions.grid"
                          [dataLabels]="chartOptions.dataLabels" [chart]="chartOptions.chart"
                        [plotOptions]="chartOptions.plotOptions" [colors]="chartOptions.colors"></apx-chart>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="body-main-section">
                <div class="body-inner-section evaluation-section">
                  <div class="card-heading evaluation-head">
                    <h1>Evaluation</h1>
                    <span>{{ evaluation_date | date:'dd MMM yyyy' }}</span>
                  </div>
                  <div class="evaluation-detail">
                    <p>{{user.first_name}} {{user.last_name}} stands out as the Exceptional Employee of
                    the Month.</p>
                  </div>
                  <div class="evaluation-rating">
                    <div class="point-rating">
                      <h1>{{evaluation ?? 0}} <span>out of 10</span></h1>
                    </div>
                    <div class="evaluation-graph">
                      <div id="pieChart" style="margin-top: 20px; width: 80%;position: relative;">
                        @if (pieChartOptions) {
                          <apx-chart [series]="pieChartOptions.series" [chart]="pieChartOptions.chart"
                            [labels]="pieChartOptions.labels" [dataLabels]="pieChartOptions.dataLabels"
                            [legend]="pieChartOptions.legend" [colors]="pieChartOptions.colors"
                            [responsive]="pieChartOptions.responsive">
                          </apx-chart>
                        }
                      </div>
                      <div class="evaluation-vlaue">
                        {{evaluation*10}}%
                      </div>
                    </div>

                  </div>
                </div>
                <div class="body-inner-section leaves-section">
                  <div class="card-heading leaves-heading">
                    <h1>Leaves Details
                      <div class="total-leaves-section">
                        <div class="info-button dashboard-info" data-toggle="modal" data-target="#leaveinfoModal"
                          (click)="remainingLeaves()">
                          <i class="fa fa-info-circle"></i>
                        </div>
                      </div>
                    </h1>
                    <ul class="nav nav-tabs border-bottom border-primary mt-2" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="Paid-tab" data-toggle="tab" data-target="#Paid" type="button"
                          role="tab" aria-controls="Paid" aria-selected="true">Paid
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link" id="Unpaid-tab" data-toggle="tab" data-target="#Unpaid" type="button"
                          role="tab" aria-controls="Unpaid" aria-selected="false">Unpaid
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div class="leave-detail-body">
                    <div class="tab-content" id="myTabContent">
                      <div class="tab-pane fade show active" id="Paid" role="tabpanel" aria-labelledby="Paid-tab">
                        <div class="leave-detail-content">
                          <div class="leave-comon-leftsection">
                            <div class="left-section-leave-main">
                              <div class="leave-inner-comon">
                                <div class="leave-circles purple-circle">
                                </div>
                                <div class="leave-content">
                                  <h1>Total Paid Leaves
                                    <span>{{(total_leaves) | number:'1.0-2'}}</span>
                                  </h1>
                                </div>
                              </div>
                              <div class="leave-inner-comon">
                                <div class="leave-circles available-circle ">
                                </div>
                                <div class="leave-content">
                                  <h1>Available Leaves
                                    <span>{{ (total_leaves - (paidLeaves + pendingLeaves))| number:'1.0-2' }}</span>
                                  </h1>
                                </div>
                              </div>
                              <div class="leave-inner-comon">
                                <div class="leave-circles availed-circle">
                                </div>
                                <div class="leave-content">
                                  <h1>Availed Leaves
                                    <span>{{(paidLeaves ?? 0) | number:'1.0-2'}}</span>
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="leave-comon-rightsection">
                            <div class="leave-circle-main-section">
                              <div class="total-leave-circle">
                                <h1>
                                  Total
                                  <span>{{total_leaves}}</span>
                                </h1>
                              </div>
                              <div class="available-leave-circle">
                                <h1>
                                  Available
                                  <span>{{ (total_leaves - (paidLeaves + pendingLeaves)) | number:'1.0-2' }}</span>
                                </h1>
                              </div>
                              <div class="availed-leave-circle">
                                <h1>
                                  Availed
                                  <span>{{(paidLeaves ?? 0) | number:'1.0-2'}}</span>
                                </h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane fade" id="Unpaid" role="tabpanel" aria-labelledby="Unpaid-tab">
                        <div class="leave-detail-content">
                          <div class="leave-comon-leftsection">
                            <div class="left-section-leave-main">
                              <div class="leave-inner-comon">
                                <div class="leave-circles purple-circle">
                                </div>
                                <div class="leave-content">
                                  <h1>Total Paid Leaves
                                    <span>{{unpaid_leave | number:'1.0-2'}}</span>
                                  </h1>
                                </div>
                              </div>
                              <div class="leave-inner-comon">
                                <div class="leave-circles available-circle ">
                                </div>
                                <div class="leave-content">
                                  <h1>Available Leaves
                                    <span>{{(unpaid_leave - unpaidLeaves) | number:'1.0-2'}} </span>
                                  </h1>
                                </div>
                              </div>
                              <div class="leave-inner-comon">
                                <div class="leave-circles availed-circle">
                                </div>
                                <div class="leave-content">
                                  <h1>Availed Leaves
                                    <span>{{(unpaidLeaves ?? 0) | number:'1.0-2'}}</span>
                                  </h1>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="leave-comon-rightsection">
                            <div class="leave-circle-main-section">
                              <div class="total-leave-circle">
                                <h1>
                                  Total
                                  <span>{{unpaid_leave | number:'1.0-2'}}</span>
                                </h1>
                              </div>
                              <div class="available-leave-circle">
                                <h1>
                                  Available
                                  <span>{{(unpaid_leave - unpaidLeaves) | number:'1.0-2'}}</span>
                                </h1>
                              </div>
                              <div class="availed-leave-circle">
                                <h1>
                                  Availed
                                  <span>{{(unpaidLeaves ?? 0) | number:'1.0-2'}}</span>
                                </h1>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div class="body-inner-section year-section">
                  <div class="card-heading">
                    <h1>Years of Work</h1>
                  </div>
                  <div class="year-work-body">
                    <h1>{{ anniversary_count }} Aniversary</h1>
                    <div class="prgress-chart">
                      <div id="progress2">
                        @if (optionsProgress3) {
                          <apx-chart [series]="optionsProgress3.series" [chart]="optionsProgress3.chart"
                            [plotOptions]="optionsProgress3.plotOptions" [colors]="optionsProgress3.colors"
                            [stroke]="optionsProgress3.stroke" [fill]="optionsProgress3.fill" [title]="optionsProgress3.title"
                            [subtitle]="optionsProgress3.subtitle" [tooltip]="optionsProgress3.tooltip"
                            [xaxis]="optionsProgress3.xaxis" [yaxis]="optionsProgress3.yaxis">
                          </apx-chart>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="year-work-timer">
                    <h1>{{aniversarydays}}<span>Days</span></h1>
                    <h1>:</h1>
                    <h1>{{aniversaryhours}} <span>Hours</span></h1>
                    <h1>:</h1>
                    <h1>{{aniversaryminutes}} <span>Minutes</span></h1>
                    <h1>:</h1>
                    <h1>{{aniversaryseconds}} <span>Seconds</span></h1>
                  </div>
                </div>
              </div>
              <div class="footer-section">
                <div class="inner-footer-sec">
                  <div class="contact-info">
                    <div class="card-heading">
                      <h1>Contact Information</h1>
                    </div>
                    <div class="contact-body">
                      <div class="contact-common">
                        <div class="contact-img">
                          <img src="../../../assets/theme1/phone.png" />
                        </div>
                        <div class="contact-detail">
                          <h1><span>Phone Number:</span> {{user.phone_number}}</h1>
                        </div>
                      </div>
                      <div class="contact-common">
                        <div class="contact-img">
                          <img src="../../../assets/theme1/mail.png" />
                        </div>
                        <div class="contact-detail">
                          <h1><span>Email:</span> {{user.email}}</h1>
                        </div>
                      </div>
                      <div class="contact-common">
                        <div class="contact-img">
                          <img src="../../../assets/theme1/location.png" />
                        </div>
                        <div class="contact-detail">
                          <h1><span>Address:</span> {{user.address.address1}} </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="birthday-section">
                    <h1>Birthday</h1>
                    <p>Make Your calendar! Your special day is coming on</p>
                    <h1>{{birthday}}
                      <img src="../../../assets/theme1/celebration.png" />
                    </h1>
                  </div>
                </div>
                <div class="gallery-section">
                  <div class="card-heading">
                    <h1>Announcements</h1>
                    <div class="gallery-rout" [routerLink]="['/announcements']">
                      <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6H13M13 6L8.5 1.5M13 6L8.5 10.5" stroke="#2D2D2E" stroke-width="2" stroke-linecap="round"
                          stroke-linejoin="round" />
                        </svg>
                      </div>
                    </div>

                    <div class="announcement-images-section">
                      <div class="annoucement-card-main">
                        @if (showDescription && latestAnnoument.status === 'active') {
                          <div class="annoucement-card-head">
                            <div class="annoucement-profile-image">
                              <img
                                [src]="latestAnnoument.user.profile_image ? latestAnnoument.user.profile_image : '../../assets/images/question.jpg'"
                                alt="admin image" />
                              </div>
                              <div class="annoucement-profile-detail">
                                <h1>{{latestAnnoument.user.first_name}} {{latestAnnoument.user.last_name}}</h1>
                                <p>{{latestAnnoument.user.description}}</p>
                              </div>
                            </div>
                          }
                          <div class="annoucement-body">
                            @if (announcementfiles && announcementfiles.length > 0) {
                              @if (showDescription || firstFile) {
                                <div class="annoucement-card-image">
                                  <a [routerLink]="['/announcements']">
                                    @if (announcementfiles[0] && isImage(announcementfiles[0])) {
                                      <img [src]="announcementfiles[0]"
                                        alt="Announcement Image" />
                                    }
                                    @if (announcementfiles[0] && isVideo(announcementfiles[0])) {
                                      <video controls>
                                        <source [src]="announcementfiles[0]" type="video/mp4" />
                                      </video>
                                    }
                                  </a>
                                  <div class="annoucement-tag">
                                    <p>New</p>
                                  </div>
                                </div>
                              }
                            }



                            @if (showDescription && latestAnnoument.status === 'active') {
                              <a [routerLink]="['/announcements']" [ngClass]="{ 'with-file': firstFile, 'no-file': !firstFile }"
                                >
                                <div class="annoucement-description">
                                  <h1>{{latestAnnoument.title}}</h1>
                                  <p class="detail-text" [innerHTML]="latestAnnoument.description"></p>
                                  <div class="card-reaction-footer">
                                    @for (reaction of getReactions(latestAnnoument.reactionCounts); track reaction) {
                                      <div class="reaction">
                                        <img class="emoji" [src]="getReactionImage(reaction.type)" [alt]="reaction.type" />
                                        <span class="count">{{ reaction.count }}</span>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </a>
                            }


                            @if (!showDescription || latestAnnoument.status !== 'active') {
                              <div class="annoucement-card-image annoucement-second-image"
                                >
                                @if (media && media.length > 4) {
                                  @if (media[4]) {
                                    <img [src]="getImagePath() + '/' + media[4].path" alt="slide">
                                  }
                                  @if (!media[4]) {
                                    <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                                  }
                                }
                              </div>
                            }
                            @if (!showDescription || latestAnnoument.status !== 'active') {
                              <div class="annoucement-small-images">
                                <div class="small-image">
                                  @if (media && media.length > 0) {
                                    @if (media[0]) {
                                      <img [src]="getImagePath() + '/' + media[0].path" alt="slide">
                                    }
                                    @if (!media[0]) {
                                      <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                                    }
                                  }
                                </div>
                                <div class="small-image">
                                  @if (media && media.length > 1) {
                                    @if (media[1]) {
                                      <img [src]="getImagePath() + '/' + media[1].path" alt="slide">
                                    }
                                    @if (!media[1]) {
                                      <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                                    }
                                  }
                                </div>
                                <div class="small-image">
                                  @if (media && media.length > 2) {
                                    @if (media[2]) {
                                      <img [src]="getImagePath() + '/' + media[2].path" alt="slide">
                                    }
                                    @if (!media[2]) {
                                      <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                                    }
                                  }
                                </div>
                                <div class="small-image">
                                  @if (media && media.length > 3) {
                                    @if (media[3]) {
                                      <img [src]="getImagePath() + '/' + media[3].path" alt="slide">
                                    }
                                    @if (!media[3]) {
                                      <img class="no-image" src="../../../../assets/theme1/computer.png" alt="slide">
                                    }
                                  }
                                </div>
                              </div>
                            }

                          </div>

                        </div>



                      </div>



                      <!-- gallery section -->
                      <!-- <div class="gallery-images-section">
                      <div class="gallery-first-sec common-gallery">
                        <img *ngIf="media?.[0]" [src]="getImagePath() + '/' + media[0]?.path" alt="slide">
                      </div>
                      <div class="gallery-second-sec common-gallery">
                        <img *ngIf="media?.[1]" [src]="getImagePath() + '/' + media[1]?.path" alt="slide">
                      </div>
                      <div class="galery-third-sec common-gallery">
                        <img *ngIf="media?.[2]" [src]="getImagePath() + '/' + media[2]?.path" alt="slide">
                        <img *ngIf="media?.[3]" [src]="getImagePath() + '/' + media[3]?.path" alt="slide">
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>



              <!-- modal -->
              <div class="modal fade" id="leaveinfoModal" tabindex="-1" role="dialog" aria-labelledby="leaveinfoModalLabel"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                  <div class="modal-content ">
                    <div class="modal-header">
                      <h5 class="modal-title" id="leaveinfoModalLabel">Leave Count Detail</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body info-modal-body">
                      <div class="row">
                        <div class="col-4 p-0">
                          <div class="col-head">
                            Category
                          </div>
                        </div>
                        <div class="col-4 p-0">
                          <div class="col-data col-center">
                            Assign Leaves
                          </div>
                        </div>
                        <div class="col-4 p-0">
                          <div class="col-data col-center">
                            Remaining Leaves
                          </div>
                        </div>
                        @for (item of remainleaves; track item) {
                          <div class="col-4 p-0">
                            <div class="col-head">
                              {{item.leave_name | titlecase
                              }} <span class="leave_type">({{item.leave_type | titlecase }})</span>
                            </div>
                          </div>
                          <div class="col-4 p-0">
                            <div class="col-data col-center assign-leave-bg">
                              <div>
                                {{item.assigned_leaves | number:'1.0-2'}}
                              </div>
                            </div>
                          </div>
                          <div class="col-4 p-0">
                            <div class="col-data col-center remaining-leave-bg">
                              <div>
                                {{(item.assigned_leaves - item.leave_count) | number:'1.0-2'}}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>

                  </div>
                </div>
              </div>